ixModuleRouting(
    "impactx.demand",
    {
        "/demanddetail/:id": {
            template:"<ixa-demand-detail></ixa-demand-detail>",
            templateUrl: "shared/purchaserequest/statusdetaildialog.tmpl.html",
            process: "DemandView",
            controller: "DemandDetailCtrl",
            controllerAs: "statusCtrl",
            workspace: "shop",
        },
        "/demanddetail": {
            template:"<ixa-demand-detail></ixa-demand-detail>",
            templateUrl: "shared/purchaserequest/statusdetaildialog.tmpl.html",
            process: "DemandView",
            controller: "DemandDetailCtrl",
            controllerAs: "statusCtrl",
            workspace: "shop",
        },
        "/demandlist": {
            template: "<ixa-demand-list></ixa-demand-list>",
            templateUrl: "modules/status/demand/templates/demandlist.html",
            process: "Demand",
            controller: "DemandListCtrl",
            controllerAs: "demandListCtrl",
            workspace: "shop",
        },
        "/readonlydemandlist": {
            template: '<ixa-demand-list-readonly></ixa-demand-list-readonly>',
            templateUrl:
                "modules/status/demand/templates/demandlistreadonly.html",
            process: "DemandListReadOnly",
            controller: "DemandListReadOnlyCtrl",
            controllerAs: "demandListReadOnlyCtrl",
            workspace: "shop",
        },
        "/approvalmodifieddei/:id": {
            template: "<ixa-approval-modified-dei></ixa-approval-modified-dei>",
            templateUrl:
                "modules/status/purchaserequest/templates/approvalmodified.html",
            process: "DemandView",
            controller: "ApprovalModifiedDemandCtrl",
            controllerAs: "approvalModifiedCtrl",
            workspace: "shop",
        },
    },
    ["ngRoute", "impactx.list", "impactx.statusicon"]
);
